/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { parse } from 'graphql/language';
import { print as onelinePrinter } from '../graphql_printer';
import APIHOST from '../const';

const Curl = ({ accessToken, query, variables, close }) => {
  let q = '';
  let v = '';
  try {
    q = onelinePrinter(parse(query));
    v = JSON.stringify(JSON.parse(variables));
  } catch (e) {
    console.log(e);
  }

  return (
    <div className="m-2.5 bg-white p-1.5 md:p-1">
      <code>
        <div className="curl-hide cursor-pointer" onClick={close}>
          {'\u2715'}
        </div>
        <div className="method-example-request include-prompt">
          <div className="break-words whitespace-pre-wrap before:content-['$_']">
            curl -s {APIHOST}/graphql \{'\n  '}
            <span className="token api-key">
              <span className="token request-flag">-u</span> {accessToken}
            </span>
            : \{'\n  '}
            <span className="token">
              <span className="token request-flag">-d</span> {`'query=${q}'`}
            </span>{' '}
            \{'\n  '}
            <span className="token">
              <span className="token request-flag">-d</span>{' '}
              {`'variables=${v}'`}
            </span>
          </div>
        </div>
      </code>
    </div>
  );
};

export default Curl;
